<template>
  <div class="empty-box">
    <div class="wrap">
      <div class="img"></div>
      <div class="txt">暂无信息</div>
    </div>
  </div>
</template>
<style lang="less" scoped>
.empty-box {
  display: flex;
  align-items: center;

  .wrap {
    margin: auto;
    width: 320px;
    background-repeat: no-repeat;
    background-size: cover;

    .img {
      height: 320px;
      background-image: url('@/assets/images/emptybox.png');
    }

    .txt {
      margin-top: 40px;
      text-align: center;
      font-weight: 400;
      font-size: 28px;
      color: #667082;
    }
  }
}
</style>
